import { Component, inject, Input } from "@angular/core";
import { SharedDsnModule } from "@app/shared/modules/shared-dsn.module";
import { SharedMaterialModule } from "@app/shared/modules/shared-material.module";
import { DeviceService } from "@app/shared/services/device.service";
import { VisualizationEntity } from "@arch/domain/entity";

@Component({
    selector: "app-report-visualization-note",
    imports: [SharedMaterialModule, SharedDsnModule],
    styles: [
        `
            .container {
                gap: var(--spacing-16);
                border-radius: var(--border-radius-8);
                padding: var(--spacing-12);
                &.reset-padding {
                    padding: 0;
                }
            }
        `
    ],
    template: `
        <div
            class="container"
            fxLayout="column"
            [class.reset-padding]="resetPadding"
        >
            <p
                class="color-text-primary"
                [class.text-12-regular]="!isMobile()"
                [class.text-10-regular]="isMobile()"
                [class.text-10-regular]="pdf"
                [innerHTML]="visualization.note.props.comment"
            ></p>
            <div fxLayout="row">
                <span
                    [class]="pdf ? 'text-8-regular' : 'text-10-regular'"
                    class="color-text-primary"
                >
                    {{ visualization.note.props.user?.name }}</span
                >

                <span fxFlex></span>
                <span
                    class="color-text-primary"
                    [class]="pdf ? 'text-10-regular' : 'text-10-regular'"
                    >{{ visualization.note.createdAtLocaleString }}</span
                >
            </div>
        </div>
    `
})
export class ReportVisualizationNoteComponent {
    @Input({ required: true }) visualization: VisualizationEntity;
    @Input({ required: false }) pdf: boolean;
    @Input({ required: false }) resetPadding: boolean;
    private readonly deviceService = inject(DeviceService);
    public readonly isMobile = this.deviceService.getIsMobile();
}
